__turbopack_context__.v({
  "action": "styles-module__WWrU3q__action",
  "actions": "styles-module__WWrU3q__actions",
  "container": "styles-module__WWrU3q__container",
  "emailAction": "styles-module__WWrU3q__emailAction",
  "phoneIcon": "styles-module__WWrU3q__phoneIcon",
  "topBar": "styles-module__WWrU3q__topBar",
});
